@use '../../../common/styles/variables' as *;
@use '../../../common/mixins/inputs' as *;

:host {
  display: block;
  height: auto;
  @include default-css-variables;
  width: 100%;
}

.nylas-event-description {
  display: flex;
  flex-direction: column;
  gap: 4px;
  position: relative;
  color: var(--nylas-base-900);

  label {
    @include input-label;
    flex-direction: column;
    gap: 4px;
    font-family: var(--nylas-font-family);

    p {
      margin: 0;
      display: flex;
      align-items: center;
    }

    span.label-icon {
      margin-left: 4px;

      tooltip-component {
        display: flex;
      }
    }
  }

  textarea {
    padding: 12px 16px;
    border-width: 1;
    resize: vertical;
    border-radius: 8px;
    font-family: var(--nylas-font-family);
    font-size: 16px;
    line-height: 24px;
    border: 1px solid var(--nylas-base-200);

    &::-webkit-resizer {
      display: none;
    }
  }

  div.event-description {
    // Apply textfield styles but override display and alignment for contentEditable
    border-radius: var(--nylas-border-radius-2x);
    border: 1px solid var(--nylas-base-300);
    background: var(--nylas-base-0);
    width: -webkit-fill-available;
    min-height: 50px;
    padding: 12px 16px;
    overflow-y: auto;
    white-space: pre-wrap;
    line-height: 1.5;
    scrollbar-width: thin;
    color: var(--nylas-base-900);
    font-family: var(--nylas-font-family);
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    -webkit-text-fill-color: var(--nylas-base-900);
    display: block;
    /* Preserves line breaks */
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }

    &:focus {
      color: var(--nylas-base-900);
      -webkit-text-fill-color: var(--nylas-base-900);
      outline: 2px solid var(--nylas-primary);
      outline-offset: 2px;
    }

    &:focus-visible {
      color: var(--nylas-base-900);
      -webkit-text-fill-color: var(--nylas-base-900);
      outline: 2px solid var(--nylas-primary);
      outline-offset: 2px;
    }

    &.error {
      border-color: var(--nylas-error);
      border-width: 2px;
    }
  }

  span.add-additional-fields {
    display: flex;
    align-items: center;
    gap: 8px;

    button-component {
      button {
        height: 35px;
        background-color: var(--nylas-base-0);
      }
    }
  }

  span.help-text {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    color: var(--nylas-base-500);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 21px;
    position: relative;

    span.label-icon {
      display: inline-flex;
      align-items: center;
      flex-shrink: 0;

      tooltip-component {
        display: flex;
        &::part(tc__container) {
          position: unset;
        }

        &::part(tc__content) {
          position: absolute;
          top: 4px;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }
  }

  .highlighted-tag {
    background-color: var(--nylas-base-200);
    border-radius: var(--nylas-border-radius);
    padding: 2px 5px;
    margin-left: 4px;
    margin-bottom: 4px;
    display: inline-block;
    vertical-align: baseline;
  }

  .token-options {
    display: block;
    background-color: var(--nylas-base-0);
    width: 100%;
    max-height: 336px;
    margin-top: 28px;
    overflow: auto;
    z-index: 1;
    border-radius: 4px;
    position: absolute;
    bottom: 108px;

    box-shadow: 0px 4px 6px -2px #0000000d;
    box-shadow: 0px 10px 15px -3px #0000001a;

    @media #{$mobile} {
      right: 0;
      width: 325px;
      max-width: unset;
    }

    ul {
      padding: 0;
      list-style-type: none;
      color: var(--nylas-base-900);
      max-height: 336px;
      margin: 0;

      li {
        padding: 16px, 12px, 16px, 12px;
        color: var(--nylas-base-900);
        padding: 12px 16px;
        text-decoration: none;
        display: block;
        font-family: inherit;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        letter-spacing: 0px;
        text-align: left;
        cursor: pointer;

        .token-label {
          display: flex;
          flex-direction: column;
          font-weight: 400;

          .token {
            color: var(--nylas-abse-900);
            font-size: 16px;
            line-height: 24px;
          }

          .description {
            color: var(--nylas-base-600);
            font-size: 14px;
            line-height: 21px;
          }
        }

        &:hover,
        &:focus,
        &:active,
        &.active {
          background-color: var(--nylas-base-100);

          .token-label {
            .token {
              color: var(--nylas-primary);
            }
          }
        }
      }
    }

    .selected {
      background-color: var(--nylas-base-100);
    }
  }
}
